export { default } from './TooltipClipboard';
